import React from "react";
import BoxData from "../Box";
import CardNav from "../CardNav";
import { Col, Row, Card } from "react-bootstrap";
import { images } from "../../../../constants";

const Inquiry = () => {
  return (
    <div>
      <Row>
        <CardNav Header="Scrap" />

        <Col lg="12">
          <Card className="shadow-main">
            <BoxData
              Title="Scrap Material"
              Butonn="Send Now"
              imgg={images.SendInquiry}
            />
          </Card>
        </Col>
      </Row>
    </div>
  );
};

export default Inquiry;
